import { observer } from 'mobx-react';
import { PropertyAppraisalsForm } from './PropertyAppraisalsForm';
import { CustomTaskDialog } from '@roc/feature-general-tasks';
import { StandardDialog } from '@roc/ui';
import { Document as DocumentType } from '@roc/feature-types';

export type PropertyAppraisalsItemProps = {
  open: boolean;
  onClose: () => void;
  properties?: any;
  document?: DocumentType;
};

export const PropertyAppraisalsItem = observer(
  ({ open, onClose, properties, document }: PropertyAppraisalsItemProps) => {
    const dialogContent = (
      <PropertyAppraisalsForm
        handleClose={onClose}
        properties={properties}
      />
    );

    return (
      <>
        {document?.taskId ? (
          <CustomTaskDialog
            open={open}
            title="Property Appraisals"
            handleClose={onClose}
            dialogContent={dialogContent}
            taskId={document.taskId}
          />
        ) : (
          <StandardDialog
            open={open}
            title="Property Appraisals"
            maxWidth="sm"
            handleClose={onClose}
            dialogContent={dialogContent}
          />
        )}
      </>
    );
  }
);

export default PropertyAppraisalsItem;
